import { render, staticRenderFns } from "./LkChangeEmail.vue?vue&type=template&id=5c1125f1&scoped=true&"
import script from "./LkChangeEmail.vue?vue&type=script&lang=js&"
export * from "./LkChangeEmail.vue?vue&type=script&lang=js&"
import style0 from "./LkChangeEmail.vue?vue&type=style&index=0&id=5c1125f1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1125f1",
  null
  
)

export default component.exports